import { FC, useState } from "react";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { getLocaleString } from "../utils/helpers";
import { ISkill, IVacancy } from "../utils/types";
import PopupContactUs from "./PopupContactUs";
import PopupVacancy from "./PopupVacancy";
import { CSSTransition } from "react-transition-group";

interface IVacancyContentProps {
  vacancy: IVacancy;
  vacancies: Array<IVacancy>;
  current: number;
}

const VacancyContent: FC<IVacancyContentProps> = ({
  vacancy,
  vacancies,
  current,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <main className="container">
      {vacancies.length === 0 ? (
        <div className="container-content not-vacancies">
         <p>{t("vacancies:emptyList")}</p> 
        </div>
      ) : (
        <>
          {current === -1 ? <div className="container-content not-vacancies"><p>{t("vacancies:notFound")}</p></div> :<><div className="sitebar-left">
            <div className="page-title vacancies services">
              <h2>
                {t("navigation:vacancies")}
                <br />
                JellyCo
              </h2>
            </div>
          </div>
          <div className="container-content our-vacancy">
            <div className="row">
              <div className="content">
                <p>{t("vacancies:text")}</p>

                <div className="vacancy">
                  <h3 id="middle-fd-react">{vacancy.name}</h3>
                  <div>
                    {t("vacancies:lookingFor")}:
                    <br />
                    {vacancy.skills?.map(({ name }) => name).join(", ")}.
                    <br />
                    {t("vacancies:requirements")}:
                    <ul>
                      {vacancy.requirements?.map(({ en, uk, id }, index) => (
                        <li key={id}>{`- ${getLocaleString({ en, uk })}`}</li>
                      ))}
                    </ul>
                    {t("vacancies:offer")}:
                    <ul>
                      {t("vacancies:offerList", { returnObjects: true }).map(
                        (item) => (
                          <li key={item}>{`- ${item}`}</li>
                        )
                      )}
                    </ul>
                  </div>
                </div>

                <h3 onClick={() => setIsOpen(true)} className="apply">
                  {t("vacancies:apply")}
                </h3>
              </div>
            </div>
          </div></>}
          <div className="sitebar-right bar-vacancy">
            <div className="services-menu">
              {vacancies.map((item, index) => (
                <Link
                  key={item.id}
                  href="/vacancies/[id]"
                  as={`/vacancies/${item.name
                    .replace(/\s/g, "_")
                    .replace(/\//g, "|")}`}
                  passHref
                >
                  <a
                    className={`vacancies-name ${
                      index === current ? "active" : ""
                    }`}
                  >
                    {item.name}
                  </a>
                </Link>
              ))}
            </div>
          </div>
          <CSSTransition
            in={isOpen}
            timeout={{ enter: 500, exit: 500 }}
            unmountOnExit
            classNames={"smooth"}
          >
            <PopupVacancy vacancy={vacancy} onClose={() => setIsOpen(false)} />
          </CSSTransition>
        </>
      )}
      {/* {isOpen && (
        <PopupVacancy vacancy={vacancy} onClose={() => setIsOpen(false)} />
      )} */}
    </main>
  );
};

export default VacancyContent;
